//搜索Columns
// import BASE_API from '@/api/dataBase.js';
// import API from '@/api/masterData/personnel';
import { getUserCompanyList } from '@/common/js/util';
export const searchColumns = (ctx) => {
  return [
    {
      name: '公司',
      prop: 'companyCode',
      type: 'select',
      options: getUserCompanyList(),
      clearable: true,
      filterable: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '部门',
      prop: 'departmentCode',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.queryData.companyCode,
    },
    {
      name: '标题',
      prop: 'title',
      type: 'input',
    },
    {
      name: '类型',
      prop: 'type',
      type: 'select',
      placeholder: '全部类型',
      options: [
        { value: '01', label: '通知' },
        { value: '02', label: '公告' },
      ],
    },
    {
      name: '创建开始时间',
      prop: 'noticeSearchDateStart',
      type: 'startDaterangePicker',
    },

    {
      name: '创建结束时间',
      prop: 'noticeSearchDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '创建人',
      prop: 'createPersonName',
      type: 'input',
    },
  ];
};
